import { useEffect, useState } from 'react'

export function useLessonPlayer(frames) {
  const total = frames.length
  const [index, setIndex] = useState(0)

  const clamp = (i) => Math.max(0, Math.min(total - 1, i))

  const goTo = (i) => setIndex(clamp(i))
  const next = () => setIndex((i) => clamp(i + 1))
  const prev = () => setIndex((i) => clamp(i - 1))

  useEffect(() => {
    const onKey = (e) => {
      const k = e.key
      if (k === 'ArrowRight' || k === 'ArrowDown' || k === ' ') {
        e.preventDefault()
        setIndex((i) => clamp(i + 1))
      } else if (k === 'ArrowLeft' || k === 'ArrowUp') {
        e.preventDefault()
        setIndex((i) => clamp(i - 1))
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [total])

  return { frame: frames[index], index, total, next, prev, goTo }
}
